import React, { useState, useEffect } from 'react';
import { useConfiguracion } from '@/context/ConfiguracionContext';
import revvlyLogo from '@/img/revvly.png';

// Logo principal de Revvly
const REVVLY_LOGO = revvlyLogo;

/**
 * Componente para mostrar el logo de la aplicación
 */
const Logo = ({ className = '', defaultText = 'Revvly', height = 40, width = 'auto' }) => {
  const { configuracion, loading: configLoading } = useConfiguracion();
  const [logoUrl, setLogoUrl] = useState(REVVLY_LOGO);

  useEffect(() => {
    if (!configLoading) {
      if (configuracion?.Logo) {
        // Usar logo personalizado si existe
        setLogoUrl(configuracion.Logo);
      } else {
        // Usar logo principal de Revvly como fallback
        setLogoUrl(REVVLY_LOGO);
      }
    }
  }, [configuracion, configLoading]);

  // Determinar el tamaño de texto basado en la altura proporcionada
  const getFontSize = () => {
    if (height <= 32) return 'text-sm';
    if (height <= 40) return 'text-base';
    if (height <= 60) return 'text-lg';
    return 'text-xl';
  };

  // Mostrar el logo o texto por defecto
  return (
    <div className={`flex items-center justify-center ${className}`}>
      {configLoading ? (
        // Mostrar el logo de Revvly durante la carga
        <img 
          src={REVVLY_LOGO} 
          alt="Revvly" 
          style={{ height, width, maxHeight: height, maxWidth: width === 'auto' ? 'none' : width }} 
          className="object-contain max-w-full transition-opacity opacity-70"
        />
      ) : !logoUrl ? (
        // Si no hay logo, mostrar texto por defecto
        <div className={`${getFontSize()} font-bold text-blue-600 text-center`}>
          {defaultText}
        </div>
      ) : (
        // Mostrar el logo (personalizado o Revvly) con manejo de errores
        <img 
          src={logoUrl} 
          alt={defaultText} 
          style={{ height, width, maxHeight: height, maxWidth: width === 'auto' ? 'none' : width }} 
          className="object-contain max-w-full transition-opacity"
          onError={(e) => {
            // Si la imagen falla, usar el logo de Revvly como fallback
            //console.log('Error al cargar logo, usando logo Revvly');
            setLogoUrl(REVVLY_LOGO);
          }}
        />
      )}
    </div>
  );
};

export default Logo;
